import { defineRelease } from '../types'

const SETTINGS_ADMINS = ['iam_org_admin', 'iam_superadmin', 'ticketing_admin']

export default defineRelease({
  version: '2026.10.5',
  date: '2026-10-23',
  summary: 'Move to MultiAccess from Request Tracker.',
  entries: [
    {
      id: 'import-from-request-tracker',
      type: 'new',
      module: 'helpdesk',
      title: 'Import your tickets from Request Tracker',
      body: 'Bring over tickets with their replies, internal comments, attachments and history, plus agents, queues, statuses and custom fields. Preview everything before importing, and run it again later to pick up new tickets.',
      link: { to: '/tickets/settings?section=migration', label: 'Open Import & Migration' },
      roles: SETTINGS_ADMINS,
      service: 'ticket-mgmt',
    },
    {
      id: 'request-tracker-sync',
      type: 'new',
      module: 'helpdesk',
      title: 'Keep imported tickets in sync with Request Tracker',
      body: 'Sync now brings over new RT tickets plus new replies and changes on tickets you already imported, so both teams can keep working during the move. If a field was changed in both places, you choose which value to keep.',
      link: { to: '/tickets/settings?section=migration', label: 'Open Import & Migration' },
      roles: SETTINGS_ADMINS,
      service: 'ticket-mgmt',
    },
    {
      id: 'undo-ticket-import',
      type: 'new',
      module: 'helpdesk',
      title: 'Undo an import',
      body: 'Remove the tickets, files and unused settings an import brought in, after a preview of exactly what goes. Tickets your team has already worked on are always kept.',
      link: { to: '/tickets/settings?section=migration', label: 'Open Import & Migration' },
      roles: SETTINGS_ADMINS,
      service: 'ticket-mgmt',
    },
  ],
})
